import React, { Component } from "react";

export default class HeadingContainer extends Component {
  render() {
    return (
      <div className="heading-container">
        <h1 style={this.props.headingStyle} className="page-heading">
          {this.props.heading}
        </h1>
        <div className="page-content">{this.props.children}</div>
      </div>
    );
  }
}
